import { NavigateFunction, NavigateOptions, To, useNavigate } from 'react-router-dom';

import { useInstanceId } from './useInstanceId';

export function useNamespacedNavigate() {
  const navigate = useNavigate();
  const { instanceId } = useInstanceId();

  type NavigateReturnType = ReturnType<typeof navigate>;

  function namespacedNavigate(to: To, options?: NavigateOptions): NavigateReturnType;
  function namespacedNavigate(delta: number): NavigateReturnType;
  function namespacedNavigate(...args: [To, NavigateOptions?] | [number]): NavigateReturnType {
    const to = args[0];
    const options = args.length > 1 ? args[1] : undefined;

    if (typeof to === 'number') {
      return navigate(to);
    }

    const prefixIfNeeded = (pathname: string) => {
      const shouldPrepend =
        pathname.startsWith('/') && !pathname.startsWith(`/instances/${instanceId}`);
      return shouldPrepend ? `/instances/${instanceId}${pathname}` : pathname;
    };

    if (typeof to === 'string') {
      return navigate(prefixIfNeeded(to), options);
    }

    const next = to?.pathname ? { ...to, pathname: prefixIfNeeded(to.pathname) } : to;

    return navigate(next, options);
  }

  // Optionally, enforce that it's assignable to Navigate
  return namespacedNavigate satisfies NavigateFunction;
}
